import { handleActions } from "redux-actions";
import immutable from "immutability-helper";
import { ActionTypes } from "../constants";

export const twoFAState = {
    is2FARequired: false,
    is2FAVerified: false,
    status: "idle",
    response: null,
};

export default {
    twofa: handleActions(
        {
            [ActionTypes.VERIFY_2FA]: (state) =>
                immutable(state, {
                    status: { $set: "running" },
                }),

            [ActionTypes.VERIFY_2FA_SUCCESS]: (state, { payload }) =>
                immutable(state, {
                    is2FAVerified: { $set: true },
                    is2FARequired: { $set: false },
                    status: { $set: "success" },
                    response: { $set: payload },
                }),

            [ActionTypes.VERIFY_2FA_ERROR]: (state, { error }) =>
                immutable(state, {
                    is2FAVerified: { $set: false },
                    status: { $set: "error" },
                    response: { $set: error },
                }),
        },
        twoFAState
    ),
};
